import { render, staticRenderFns } from "./AboutAll.vue?vue&type=template&id=0ac579fc&scoped=true"
import script from "./AboutAll.vue?vue&type=script&lang=js"
export * from "./AboutAll.vue?vue&type=script&lang=js"
import style0 from "./AboutAll.vue?vue&type=style&index=0&id=0ac579fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac579fc",
  null
  
)

export default component.exports